import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Creators from "@/pages/Creators";
import CreatorDetail from "@/pages/CreatorDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Favorites from "@/pages/Favorites";
import Account from "@/pages/Account";
import SellerApply from "@/pages/SellerApply";
import SellerDashboard from "@/pages/SellerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import StaticPage from "@/pages/StaticPage";
import { Login, Register, Forgot, Reset } from "@/pages/Auth";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <FavoritesProvider>
          <CartProvider>
            <Toaster position="top-center" toastOptions={{ style: { borderRadius: 0, fontFamily: "Jost, sans-serif", fontSize: "0.72rem", letterSpacing: "0.08em" } }} />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/catalogue" element={<Catalog />} />
                <Route path="/c/:slug" element={<Catalog />} />
                <Route path="/produit/:id" element={<ProductDetail />} />
                <Route path="/createurs" element={<Creators />} />
                <Route path="/createur/:id" element={<CreatorDetail />} />
                <Route path="/panier" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/favoris" element={<Favorites />} />
                <Route path="/compte" element={<Account />} />
                <Route path="/devenir-createur" element={<SellerApply />} />
                <Route path="/espace-createur" element={<SellerDashboard />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/page/:slug" element={<StaticPage />} />
                <Route path="/connexion" element={<Login />} />
                <Route path="/inscription" element={<Register />} />
                <Route path="/mot-de-passe-oublie" element={<Forgot />} />
                <Route path="/reset-password" element={<Reset />} />
              </Routes>
            </Layout>
          </CartProvider>
        </FavoritesProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
